import { Link } from 'gatsby';
import { AnalyticsEvent, trackCustomEvent } from '../../utils/analytics';
import Logo from '../../assets/images/logo.svg';
import { useCallback, useEffect, useRef, useState } from 'react';

const LINKS = [
  {
    label: 'The Cause',
    href: '/#cause',
  },
  {
    label: 'Speakers',
    href: '/#speakers',
  },
  {
    label: 'Schedule',
    href: '/#schedule',
  },
  {
    label: 'Sponsors',
    href: '/#sponsors',
  },
  {
    label: 'Organizer',
    href: '/#organizer',
  },
];

const TOP_TRANSFORM = 20;

export const Navigation = () => {
  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  const toggleSticky = useCallback((scrollY) => {
    if (scrollY > TOP_TRANSFORM) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      toggleSticky(window.pageYOffset);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [toggleSticky]);

  return (
    <header
      ref={headerRef}
      className="fixed left-0 right-0 z-20 transition-transform duration-500"
      style={{
        transform: isSticky
          ? `translateY(${-TOP_TRANSFORM}px)`
          : 'translateY(0)',
      }}
    >
      <div
        className={`absolute -z-10 inset-0 bg-gradient-to-b from-translucent-background-70 to-transparent transition-opacity duration-500 ${
          isSticky ? 'opacity-100' : 'opacity-0'
        }`}
      />

      <div className="container mx-auto px-4 lg:px-8 pt-6 md:pt-12 pb-1 md:pb-6 flex justify-between items-center">
        <Link to="/">
          <img
            className="h-6 lg:h-8"
            src={Logo}
            alt="GDG DevFest Ukraine 2022"
          />
        </Link>

        <nav className="flex items-center">
          <ul className="hidden lg:flex menu menu-horizontal p-0">
            {LINKS.map(({ label, href }, index) => (
              <li
                key={label}
                className={`mr-2 ${index === 0 ? 'hidden xl:block' : ''}`}
              >
                <Link to={href}>{label}</Link>
              </li>
            ))}
          </ul>

          <Link
            to="/#tickets"
            className="hidden md:inline-flex btn btn-primary"
            onClick={() => {
              trackCustomEvent({
                category: 'Navigation',
                action: AnalyticsEvent.CTA,
                label: 'Tickets',
              });
            }}
          >
            Session recordings
          </Link>

          <div className="ml-4 dropdown dropdown-end lg:hidden">
            <label tabIndex={0} className="btn btn-ghost btn-circle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-neutral-800 rounded-box w-52"
            >
              {LINKS.map(({ label, href }) => (
                <li key={label}>
                  <Link to={href}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};
